import { Card, CardContent, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectTodayTotals } from "../../store/selectors";
import { selectTargetCalories } from "../../store/personalSelectors";

export default function TodayHeaderCard(){

  const totalCalories = useSelector(selectTodayTotals);
  const targetCalories = useSelector(selectTargetCalories);

  const calorieBalance =
    targetCalories && totalCalories !== undefined
      ? targetCalories - totalCalories
      : null;

  return (
    <Card sx={{ mb:2}}>
      <CardContent sx={{p:"8px !important"}}>

        <Typography variant="h6">
          🔥 {totalCalories.toFixed(0)} kcal today
        </Typography>

        {targetCalories && (
          <div>
            Target: {targetCalories} | Eaten: {totalCalories.toFixed(0)} | Remaining: {calorieBalance?.toFixed(0)}
          </div>
        )}

      </CardContent>
    </Card>
  )
}